import * as types from './types';

const getProductsPosting = (currentPlanId = '', postingId = '') => ({
  type: types.GET_PRODUCTS,
  meta: {
    async: true,
    blocking: false,
    api: 'ecommerce',
    path: `/ecommerce/api/v1/products/posting/${postingId}`,
    headers: { 'X-NAVENT-APP': 'publicador' },
    method: 'GET',
    query: { userType: 'particular', currentPlanId }
  }
});

const getCredits = postingId => ({
  type: types.GET_CREDITS,
  meta: {
    async: true,
    blocking: false,
    api: 'publicador',
    path: `/publicador/api/v1/credits?postingId=${postingId}`,
    method: 'GET'
  }
});

const selectAvailablePlan = plan => ({
  type: types.SELECT_PLAN,
  payload: plan
});

const cleanResponse = prop => ({
  type: types.CLEAN_RESPONSE,
  payload: prop
});

export { getCredits, selectAvailablePlan, cleanResponse, getProductsPosting };
